import TrackingElement from '../../elements/tracking/TrackingElement';
import pushEcommerceTrackingEvent from '../../elements/tracking/helpers/pushEcommerceTrackingEvent';
import BuyBoxEvents from '../../structures/_buy-box/buy-box/BuyBoxEvents';
import { formatNumber } from '../../elements/tracking/helpers/number-formatter';
import toTrackableProduct from '../../elements/tracking/transformer/toTrackableProduct';
import CurrencyFormatter from '../../../js/helper/currency-formatter';

class ProductPageTracking extends TrackingElement {
    connected() {
        super.connected();

        if (this.$trackingTarget) {
            this.$trackingTarget.addEventListener(BuyBoxEvents.VARIANT_CHANGE, ({ detail: selectedVariant }) => {
                // avoid tracking of product on first call
                if (!this.product) {
                    return;
                }
                this.selectedVariant = selectedVariant;
                this.trackProductDetail('productDetail');
            });

            this.$trackingTarget.addEventListener(BuyBoxEvents.ADD_TO_CART, () => {
                this.trackProductDetail('add_to_cart');
            });
        }
    }

    getTrackingTarget() {
        return document.querySelector('product-page');
    }

    properties() {
        return {
            selectedVariant: null,
        };
    }

    get product() {
        if (this.$trackingTarget) {
            return this.$trackingTarget.product;
        }
        return undefined;
    }

    get variant() {
        if (this.selectedVariant) {
            return this.selectedVariant;
        }
        return this.product ? this.product.variants[this.product.requestedSku] : null;
    }

    trackProductDetail(eventName) {
        if (!this.variant) {
            return;
        }

        pushEcommerceTrackingEvent(eventName, {
            currency: CurrencyFormatter.currency(),
            value: formatNumber(this.variant?.price),
            items: [
                {
                    index: 0,
                    ...toTrackableProduct(this.product, this.variant),
                },
            ],
        });
    }
}

customElements.define('product-page-tracking', ProductPageTracking);
